export default __webpack_public_path__ + "static/media/forms.7d3298c7.png";